import useScheduleCallback from './useScheduleCallback'
import { useTranslation } from 'react-i18next'
import {
  PopoverList,
  PopTitle,
  PopItem,
} from '@/containers/SubscriptionFormPageNew/Components/ScheduleCallback/styled-components'

const ScheduleCallbackPopOverContent = () => {
  const { t } = useTranslation()
  const { hasUpcoming, upcomingItems, popOverTitleKey } = useScheduleCallback()

  const items = Array.isArray(upcomingItems) ? upcomingItems : []

  if (!hasUpcoming || !items.length) return null

  return (
    <PopoverList>
      <PopTitle>{t(popOverTitleKey)}</PopTitle>

      {items.map(item => {
        const scheduleAtDate = item?.scheduledAt ? new Date(item.scheduledAt) : null
        const scheduleAtDateString = scheduleAtDate ? scheduleAtDate.toLocaleString() : '-'
        return (
          <PopItem key={item.id}>
            <div>{scheduleAtDateString}</div>
            {item.contactPhone && <div>{item.contactPhone}</div>}
            {item.contactEmail && <div>{item.contactEmail}</div>}
          </PopItem>
        )
      })}
    </PopoverList>
  )
}

export default ScheduleCallbackPopOverContent
